
import "./Css/CumissionManagement.css";
import { useNavigate } from 'react-router-dom'
import React, { useState, useEffect } from "react";


const exams = [
  {
    id: 1,
    name: "ज्ञानदीप इंग्लिश स्कूल",
    totalbook: "1१",
    tcumission: "₹ ५५",
    paid: "₹ ५५",
    baki: "₹ 0",
    date: "७ फेब्रुवारी , २०२५",  
  },
  {
    id: 2,
    name: "सह्याद्री इंग्लिश स्कूल, सातारा",
    totalbook: "21",
    tcumission: "₹ 105",
    paid: "₹ 105",
    baki: "₹ 0",
    date: "5 फेब्रुवारी , २०२५",
  },
   {
    id: 3,
    name: "ज्ञानदीप विद्यालय, फलटण",
    totalbook: "15",
    tcumission: "₹ 75",
    paid: "₹ 75",
    baki: "₹ 0",
    date: "2 फेब्रुवारी , २०२५",
  },
  {
    name: "अर्चना विद्यामंदिर, पाटण",
    totalbook: "13",
    tcumission: "₹ 65",
    paid: "₹ 0",
    baki: "₹ 65",
    date: "५ जानेवारी, २०२५",
  },
   {
    id: 5,
    name: "शिवगंगा विद्या निकेतन, सातारा",
    totalbook: "12",
    tcumission: "₹ 60",
    paid: "₹ 60",
    baki: "₹ 0",
    date: "७ फेब्रुवारी , २०२५",
  },
  {
    id: 6,
    name: "ज्ञानदीप इंग्लिश स्कूल",
    totalbook: "1१",
    tcumission: "₹ ५५",
    paid: "₹ ५५",
    baki: "₹ 0",
    date: "७ फेब्रुवारी , २०२५",
  },
];

const CumissionManagement = () => {
   const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
      const [rowsPerPage, setRowsPerPage] = useState(5);
const [searchQuery, setSearchQuery] = useState('');
 const [deleteIndex, setDeleteIndex] = useState(null);
 const [examList, setExamList] = useState(exams);
const [showDeletePopup, setShowDeletePopup] = useState(false);
        
const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setShowDeletePopup(true);
  };
 const confirmDelete = () => {
  const updatedExams = [...examList];
  updatedExams.splice(deleteIndex, 1);
  setExamList(updatedExams);
  setShowDeletePopup(false);
  setDeleteIndex(null);
};

  const cancelDelete = () => {
    setShowDeletePopup(false);
    setDeleteIndex(null);
  };
  const handleViewClick = (index) => {
  navigate("/dashboard/cumissionview"); 
};

const filteredData = examList.filter((exam) =>
  exam.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
  exam.id.toString().includes(searchQuery)
);


const totalPages = Math.ceil(filteredData.length / rowsPerPage);

const paginatedData = filteredData.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);

  return (
    <div className="exam-page">
      {/* Header */}
      <div className="exam-header">
        <h3>कमिशन व्यवस्थापन</h3>
        <button className="primary-btn" onClick={() => navigate("/dashboard/createcumission")}>दिलेले कमिशन जोडा</button>
      </div>
 <div className="filters">
<div className="search-wrapper-exam">
<svg xmlns="http://www.w3.org/2000/svg" className="search-icon-exam" height="20" width="20" viewBox="0 0 24 24" fill="#888">
<path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="#848484"/></svg>
<input className="udises" type="text" placeholder="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
</div>

        <select>
          <option> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M9.3845 8.3845V7.3845H17.6155V8.3845H9.3845ZM9.3845 11.1538V10.1538H17.6155V11.1538H9.3845ZM14.2308 21V18.7905L19.5635 13.4827C19.6622 13.3968 19.7647 13.3333 19.8712 13.2923C19.9776 13.2513 20.084 13.2308 20.1905 13.2308C20.3007 13.2308 20.4122 13.2522 20.525 13.2952C20.6378 13.3381 20.7372 13.4025 20.823 13.4885L21.748 14.4327C21.8302 14.5314 21.8927 14.634 21.9355 14.7405C21.9785 14.8468 22 14.9532 22 15.0595C22 15.166 21.9827 15.2734 21.948 15.3818C21.9135 15.4901 21.8468 15.5936 21.748 15.6923L16.4405 21H14.2308ZM20.1905 16.0155L21.1155 15.0595L20.1905 14.1155L19.2405 15.0655L20.1905 16.0155ZM6 21C5.43583 21 4.9615 20.8077 4.577 20.423C4.19233 20.0385 4 19.5642 4 19V16.2308H7V3H20V10.8712C19.8205 10.8762 19.6497 10.8952 19.4875 10.928C19.3253 10.9607 19.1628 11.0071 19 11.0673V4H8V16.2308H13.3462L11.8463 17.7308V21H6Z" fill="#616161"/>
</svg>महिना निवडा </option>
<option>फेब्रुवारी </option>
        </select>

      </div>


      {/* Stats */}
      <div className="statse">
        <div className="state purple">
             <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
  <path d="M34.1925 23.5896L23.5896 34.1925C23.3174 34.4617 23.0111 34.6635 22.6708 34.7979C22.3306 34.9326 21.9921 35 21.6554 35C21.319 35 20.9825 34.9326 20.6458 34.7979C20.3092 34.6635 20.0063 34.4617 19.7371 34.1925L5.79792 20.2854C5.53514 20.0438 5.33653 19.756 5.20208 19.4221C5.06736 19.0882 5 18.7371 5 18.3687V7.72417C5 6.975 5.26222 6.33375 5.78667 5.80042C6.31139 5.26681 6.95722 5 7.72417 5H18.3688C18.729 5 19.0782 5.07292 19.4163 5.21875C19.7543 5.36458 20.0472 5.56083 20.295 5.8075L34.1925 19.7146C34.47 19.9871 34.6724 20.2935 34.7996 20.6337C34.9268 20.974 34.9904 21.3164 34.9904 21.6608C34.9904 22.0053 34.9268 22.344 34.7996 22.6771C34.6724 23.0099 34.47 23.314 34.1925 23.5896ZM10.9162 12.5963C11.3846 12.5963 11.7817 12.4342 12.1075 12.11C12.4333 11.7858 12.5963 11.3924 12.5963 10.9296C12.5963 10.4576 12.4342 10.0565 12.11 9.72625C11.7858 9.39597 11.3924 9.23083 10.9296 9.23083C10.4576 9.23083 10.0565 9.39472 9.72625 9.7225C9.39597 10.0503 9.23083 10.4482 9.23083 10.9162C9.23083 11.3846 9.39472 11.7817 9.7225 12.1075C10.0503 12.4333 10.4482 12.5963 10.9162 12.5963Z" fill="#8D62EE"/>
</svg></div>
        <div>
          <h4>एकूण पुस्तके विक्री</h4>
          <p>72</p>
        </div>
      </div>
       <div className="state green">
             <div className="circle"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
  <path d="M13.0437 17.7237C11.7423 17.7237 10.6318 17.2638 9.71203 16.3441C8.79203 15.4241 8.33203 14.3136 8.33203 13.0124C8.33203 11.7111 8.79203 10.6005 9.71203 9.68078C10.6318 8.76078 11.7423 8.30078 13.0437 8.30078C14.3448 8.30078 15.4554 8.76078 16.3754 9.68078C17.2951 10.6005 17.7549 11.7111 17.7549 13.0124C17.7549 14.3136 17.2951 15.4241 16.3754 16.3441C15.4554 17.2638 14.3448 17.7237 13.0437 17.7237ZM13.0416 16.057C13.8869 16.057 14.6061 15.7612 15.1991 15.1695C15.7919 14.5779 16.0883 13.8594 16.0883 13.0141C16.0883 12.1688 15.7924 11.4498 15.2008 10.857C14.6091 10.264 13.8906 9.96745 13.0454 9.96745C12.2001 9.96745 11.4811 10.2633 10.8883 10.8549C10.2952 11.4466 9.9987 12.1651 9.9987 13.0104C9.9987 13.8556 10.2945 14.5748 10.8862 15.1679C11.4779 15.7606 12.1963 16.057 13.0416 16.057ZM26.9858 31.6662C25.6847 31.6662 24.5741 31.2062 23.6541 30.2862C22.7344 29.3665 22.2745 28.2559 22.2745 26.9545C22.2745 25.6534 22.7344 24.5429 23.6541 23.6229C24.5741 22.7031 25.6847 22.2433 26.9858 22.2433C28.2872 22.2433 29.3977 22.7031 30.3174 23.6229C31.2374 24.5429 31.6974 25.6534 31.6974 26.9545C31.6974 28.2559 31.2374 29.3665 30.3174 30.2862C29.3977 31.2062 28.2872 31.6662 26.9858 31.6662ZM26.9841 29.9995C27.8294 29.9995 28.5484 29.7037 29.1412 29.112C29.7343 28.5204 30.0308 27.8019 30.0308 26.9566C30.0308 26.1113 29.7349 25.3922 29.1433 24.7991C28.5516 24.2063 27.8331 23.9099 26.9879 23.9099C26.1426 23.9099 25.4234 24.2058 24.8304 24.7974C24.2376 25.3891 23.9412 26.1076 23.9412 26.9529C23.9412 27.7981 24.237 28.5172 24.8287 29.1099C25.4204 29.703 26.1388 29.9995 26.9841 29.9995ZM9.79995 31.3458L8.65245 30.1983L30.2295 8.6212L31.377 9.7687L9.79995 31.3458Z" fill="#4B9D9D"/>
</svg></div>
        <div>
          <h4>दिलेले कमिशन</h4>
          <p>३६० ₹.</p>
        </div>
      </div>
      
      </div>

      {/* Table */}
      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>संस्थेचे नाव</th>
              <th>एकूण पुस्तक विक्री  </th>
              <th>एकूण कमिशन</th>
              <th>दिलेली रक्कम </th>
              <th>बाकी रक्कम</th>
              <th>शेवटच्या व्यवहाराची तारीख</th>
              <th>क्रिया</th>
              
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((exam, index) => (
    <tr key={exam.id}>
                <td>{index + 1}</td>
                <td>{exam.name}</td>
                <td>{exam.totalbook}</td>
                <td>{exam.tcumission}</td>
                <td>{exam.paid}</td>
                <td
  className={`baki-amount ${
    exam.baki !== "₹ 0" ? "baki-red" : "baki-green"
  }`}
>
  {exam.baki}
</td>

                <td>{exam.date}</td>
                <td className="actions">
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleViewClick(index)}  width="20" height="20" viewBox="0 0 24 24" fill="none">
  <path d="M12.0037 15.1538C13.0198 15.1538 13.8821 14.7981 14.5904 14.0868C15.2988 13.3754 15.6529 12.5117 15.6529 11.4955C15.6529 10.4793 15.2973 9.61708 14.5859 8.90875C13.8746 8.20042 13.0108 7.84625 11.9947 7.84625C10.9785 7.84625 10.1163 8.20192 9.40792 8.91325C8.69959 9.62458 8.34542 10.4883 8.34542 11.5045C8.34542 12.5207 8.70109 13.3829 9.41242 14.0913C10.1238 14.7996 10.9875 15.1538 12.0037 15.1538ZM11.9992 14.2C11.2492 14.2 10.6117 13.9375 10.0867 13.4125C9.56167 12.8875 9.29917 12.25 9.29917 11.5C9.29917 10.75 9.56167 10.1125 10.0867 9.5875C10.6117 9.0625 11.2492 8.8 11.9992 8.8C12.7492 8.8 13.3867 9.0625 13.9117 9.5875C14.4367 10.1125 14.6992 10.75 14.6992 11.5C14.6992 12.25 14.4367 12.8875 13.9117 13.4125C13.3867 13.9375 12.7492 14.2 11.9992 14.2ZM12.0019 18C9.83592 18 7.86192 17.4106 6.07992 16.2317C4.29792 15.0529 2.96334 13.4757 2.07617 11.5C2.96334 9.52433 4.29701 7.94708 6.07717 6.76825C7.85734 5.58942 9.83042 5 11.9964 5C14.1624 5 16.1364 5.58942 17.9184 6.76825C19.7004 7.94708 21.035 9.52433 21.9222 11.5C21.035 13.4757 19.7013 15.0529 17.9212 16.2317C16.141 17.4106 14.1679 18 12.0019 18Z" fill="#313030"/>
</svg> 

<svg xmlns="http://www.w3.org/2000/svg" onClick={() => handleDeleteClick(index)} width="20" height="20" viewBox="0 0 24 24" fill="none">
  <path d="M7.6155 20.0036C7.15517 20.0036 6.77083 19.8495 6.4625 19.5411C6.15417 19.2328 6 18.8485 6 18.3881V6.00363H5V5.00363H9V4.23438H15V5.00363H19V6.00363H18V18.3881C18 18.8485 17.8458 19.2328 17.5375 19.5411C17.2292 19.8495 16.8448 20.0036 16.3845 20.0036H7.6155ZM9.80775 17.0036H10.8078V8.00363H9.80775V17.0036ZM13.1923 17.0036H14.1923V8.00363H13.1923V17.0036Z" fill="#FF1501"/>
</svg>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
       {showDeletePopup && (
        <div className="delete-popup-overlay" onClick={cancelDelete}>
          <div className="delete-popup-box delete-confirm-box" onClick={(e) => e.stopPropagation()}>
            <div className="delete-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 32 36" fill="none">
  <path d="M6 36C4.9 36 3.95833 35.6083 3.175 34.825C2.39167 34.0417 2 33.1 2 32V6C1.43333 6 0.958333 5.80833 0.575 5.425C0.191667 5.04167 0 4.56667 0 4C0 3.43333 0.191667 2.95833 0.575 2.575C0.958333 2.19167 1.43333 2 2 2H10C10 1.43333 10.1917 0.958333 10.575 0.575C10.9583 0.191667 11.4333 0 12 0H20C20.5667 0 21.0417 0.191667 21.425 0.575C21.8083 0.958333 22 1.43333 22 2H30C30.5667 2 31.0417 2.19167 31.425 2.575C31.8083 2.95833 32 3.43333 32 4C32 4.56667 31.8083 5.04167 31.425 5.425C31.0417 5.80833 30.5667 6 30 6V32C30 33.1 29.6083 34.0417 28.825 34.825C28.0417 35.6083 27.1 36 26 36H6ZM26 6H6V32H26V6ZM12 28C12.5667 28 13.0417 27.8083 13.425 27.425C13.8083 27.0417 14 26.5667 14 26V12C14 11.4333 13.8083 10.9583 13.425 10.575C13.0417 10.1917 12.5667 10 12 10C11.4333 10 10.9583 10.1917 10.575 10.575C10.1917 10.9583 10 11.4333 10 12V26C10 26.5667 10.1917 27.0417 10.575 27.425C10.9583 27.8083 11.4333 28 12 28ZM20 28C20.5667 28 21.0417 27.8083 21.425 27.425C21.8083 27.0417 22 26.5667 22 26V12C22 11.4333 21.8083 10.9583 21.425 10.575C21.0417 10.1917 20.5667 10 20 10C19.4333 10 18.9583 10.1917 18.575 10.575C18.1917 10.9583 18 11.4333 18 12V26C18 26.5667 18.1917 27.0417 18.575 27.425C18.9583 27.8083 19.4333 28 20 28Z" fill="#FF0000"/>
</svg>
              <h3>डिलेक्ट करा</h3>
              <p>कमिशन एंट्री हटवण्याची खात्री करा,
ही क्रिया मागे घेतली जाऊ शकत नाही.</p>
            </div>
            <div className="delete-popup-buttons">
              <button className="delete-cancel-btn" onClick={cancelDelete}>नाही </button>
              <button className="delete-confirm-btn" onClick={confirmDelete}>होय </button>
            </div>
          </div>
        </div>
      )}
     <div className='que-pagination-container'>
      <div className="que-pagination-controlss">
        <button
          className="que-pagination-btn"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
         &lt;
        </button>

        {[...Array(totalPages).keys()]
          .map((_, i) => i + 1)
          .slice(
            Math.max(currentPage - 2, 0),
            Math.min(currentPage + 1, totalPages)
          )
          .map((page) => (
            <button
              key={page}
              className={`que-pagination-btn ${
                currentPage === page ? 'active' : ''
              }`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}

        <button
          className="que-pagination-btn"
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
           &gt;
        </button>
         {/* Rows per page and range info */}
      <div className="que-pagination-controls">
        <span className="que-rows-label">Rows per page:</span>
        <select
          value={rowsPerPage}
          onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1);
          }}
          className="que-rows-dropdown"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
        </select>
</div>
      </div>
</div>
    </div>
  );
};

export default CumissionManagement;
